import ra from "remove-accents";
import slug from "slugify";

export const sluggify = (str: string) => {
  return slug(ra.remove(str.trim()).replaceAll("-", " "), {
    replacement: "_",
    lower: true,
    strict: true,
  });
};

export const beautify = (str: string, ampersand?: boolean) => {
  let newStr = str.replaceAll("_", " ");
  if (ampersand) {
    newStr = newStr.replace(/\band\b/gi, "&");
  }
  return newStr;
};

export const unBeautify = (str: string) => {
  return str.replaceAll(" ", "_");
};

export const pluralize = (count: number, word: string, suffix = "s") =>
  `${count} ${word}${count !== 1 ? suffix : ""}`;

export const capitalize = (s: string, separator?: "-") =>
  s.length > 0
    ? separator
      ? s
          .split(separator)
          .map((v) => v[0]?.toUpperCase() + v.slice(1))
          .join(" ")
      : s[0]?.toUpperCase() + s.slice(1)
    : s;

export function escapeString(value: string): string {
  if (!value) return "";

  // Escape double quotes by replacing them with two double quotes
  const escapedValue = value.replace(/"/g, '""');

  // Enclose in double quotes if it contains commas, newlines, or double quotes
  if (/[",\n]/.test(escapedValue)) {
    return `"${escapedValue}"`;
  }

  return escapedValue;
}
